export const MetadataTypes = {
  Genre: 1,
  Cast: 2,
  Tags: 3,
  Categories: 4,
  Countries: 5,
  Demographics: 6,
};

export const MediaAvailability = {
  NonExclusive: 1,
  Exclusive: 2,
};

export const RushDurationPrice = {
  Annual: 'annual',
  Unlimited: 'unlimited',
};
